import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function EventStaffingCta() {
  return (
    <section className="es-cta-section container-fluid horizontal-padding">
      <motion.div
        className="es-cta-card"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.75, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {/* Ambient background glows */}
        <div className="es-cta-ambient-glow-bottom" />
        <div className="es-cta-ambient-glow-right" />

        <div className="row align-items-center position-relative es-cta-row">
          {/* Left Column: Headline & CTA Button */}
          <div className="col-12 col-lg-5 es-cta-left">
            <motion.h2
              className="es-cta-title"
              initial={{ opacity: 0, x: -25 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.65, delay: 0.1 }}
            >
              Need a booking or staffing platform built around your workflow?
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.25 }}
            >
              <Link
                to="/contact-us"
                className="es-cta-btn"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Connect with sprigstack <span className="arrow">→</span>
              </Link>
            </motion.div>
          </div>

          {/* Right Column: 3D Tablet Mockup with Floating Animation */}
          <div className="col-12 col-lg-7 es-cta-right">
            <motion.div
              className="es-cta-img-wrap"
              initial={{ opacity: 0, scale: 0.95, x: 30 }}
              whileInView={{ opacity: 1, scale: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
                delay: 0.15,
              }}
            >
              {/* Pulsing golden backlight behind the tablet */}
              <motion.div
                className="es-cta-mockup-glow"
                animate={{
                  opacity: [0.45, 0.8, 0.45],
                  scale: [0.96, 1.04, 0.96],
                }}
                transition={{
                  duration: 4.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />

              {/* Gentle floating motion */}
              <motion.div
                className="es-cta-floating-img"
                animate={{ y: [-6, 6, -6] }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.015 }}
              >
                <img
                  src="/images/event-staffing/even-staffing-cta.png"
                  alt="Event Staffing Platform Workflow - Connect with SprigStack"
                  className="es-cta-img"
                  loading="lazy"
                />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
